if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        if(this.form.querySelector('[name=id]') != null) this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.productGridForm = this.classList.contains('product-grid-form');
        this.variantSwatches = this.form.querySelectorAll('[data-variant-swatch]');
        this.subOptions = this.form.querySelectorAll('.product_subscription_type input')
        let productForms = document.querySelectorAll('[data-grid-prd-form]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        if(this.productGridForm){
          var _this = this;


          this.variantSwatches.forEach(swatch => {
            // console.log('initial swatch', swatch);
            this.onVariantSwatchChange(swatch,'variant-swatch');
          });

          this.subOptions.forEach(subOption => {
            // console.log('initial swatch', swatch);
            this.onVariantSwatchChange(subOption,'sub-options');
          });

          // _this.onVariantSwatchChange(_this.variantSwatches);
          if(window.innerWidth > 1100){
            this.addEventListener('mouseover',function(e){
              _this.openATCPanel(this,_this,productForms);
            });
            this.querySelector('button').addEventListener('focus',function(e){
              _this.openATCPanel(this.closest('.product-grid-form'),_this,productForms);
            });
            this.addEventListener('mouseout',function(e){
              _this.closeATCPanel(this);
            })
          } else{
            if(this.querySelector('[data-add-step][type="submit"]') != null) this.querySelector('[data-add-step][type="submit"]').type = 'button';
            this.addEventListener('click',function(e){
              e.stopPropagation();
              if(!e.target.matches('label.variant-label') && !e.target.matches('input[name="id"]')){ // dont close if same box is being clicked
                _this.openATCPanel(this,_this,productForms);
              }
            });

            document.querySelector('body').addEventListener('click',function(e){
              e.stopPropagation();
              // console.log('clickkk',e.currentTarget , _this);
              if(e.currentTarget != _this){
                _this.closeATCPanel(_this);
              }
            })
          }
          
          document.querySelectorAll('[data-grid-prd-form] input[name="id"]').forEach(function(input){
            input.addEventListener('change',function(e){
              e.stopImmediatePropagation();
              let form = this.closest('form');
              const soldOutMessage = form.querySelector('.sold-out-message');
              // console.log('changee',input,input.hasAttribute('data-soldout'));
              if(input.hasAttribute('data-soldout')){
                if (!soldOutMessage) return;
                form.querySelector('button[name="add"]').setAttribute('aria-disabled', true);
                form.querySelector('button[name="add"]').querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              } else{
                if (!soldOutMessage) return;
                form.querySelector('button[name="add"]').setAttribute('aria-disabled', false);
                form.querySelector('button[name="add"]').querySelector('span').classList.remove('hidden');
                soldOutMessage.classList.add('hidden');
              }
            })  
          })
        }
      }
      onVariantSwatchChange(swatch,type){
        if(type == 'variant-swatch'){
          swatch.addEventListener('click',function(e){

            let swtch = e.currentTarget.closest('[data-card-variants]').querySelector('input[id='+e.currentTarget.getAttribute('for')+']');
            // console.log('swtahc',e.currentTarget);
            

            let subBox = e.currentTarget.closest('.atc-panel').querySelector('.product_subscription_type');
            let atcBtnPrice = e.currentTarget.closest('[data-grid-prd-form]').querySelector('[data-atc-price]');
            let freqMsg = e.currentTarget.closest('[data-grid-prd-form]').querySelector('[data-grid-freq-msg-container]');
            // console.log('atcBtnPrice',e.currentTarget.closest('[data-grid-prd-form]'),subBox.querySelector('.onetime-option [data-atc-prc]'));
           

            if(subBox != null){
              console.log('hihihihih');
               // change prices
              // if(subBox.querySelector('[data-cur-comp-price]') != null) subBox.querySelector('[data-cur-comp-price]').innerHTML = swtch.dataset.comPrice;
              if(subBox.querySelectorAll('[data-cur-comp-price]') != null) subBox.querySelectorAll('[data-cur-comp-price]').forEach((ele) => {ele.innerHTML = swtch.dataset.comPrice;})
              if(subBox.querySelectorAll('[data-cur-price]') != null) subBox.querySelectorAll('[data-cur-price]').forEach((ele) => {ele.innerHTML = swtch.dataset.price;})
              if(subBox.querySelector('.onetime-option [data-atc-prc]') != null) subBox.querySelector('.onetime-option [data-atc-prc]').dataset.atcPrc = swtch.dataset.price;
              if(subBox.querySelector('[data-cur-sub-price]') != null) subBox.querySelector('[data-cur-sub-price]').innerHTML = swtch.dataset.subPrice;
              if(subBox.querySelector('.subscription-option [data-atc-prc]') != null) {
                subBox.querySelector('.subscription-option [data-atc-prc]').dataset.atcPrc = swtch.dataset.subPrice;
                if(swtch.dataset.sellingPlan != undefined && swtch.dataset.sellingPlan != '' ){
                  subBox.querySelector('.subscription-option [data-atc-prc]').value = swtch.dataset.sellingPlan;
                }
                
              }
  
              // change percentages
              if(subBox.querySelector('[data-cur-comp-discount]') != null) subBox.querySelector('[data-cur-comp-discount]').innerHTML = '-'+swtch.dataset.compDiscount + '%';
              console.log(swtch);
      console.log('swtch.dataset.subDiscount');
              if(subBox.querySelector('[data-cur-sub-discount]') != null) subBox.querySelector('[data-cur-sub-discount]').innerHTML = '-'+swtch.dataset.subDiscount + '%';

            }

            if(atcBtnPrice != null) {
              if(subBox != null){ // subscription exists
                atcBtnPrice.innerHTML = subBox.querySelector('input:checked').dataset.atcPrc;
              } else{
                atcBtnPrice.innerHTML = swtch.dataset.subPrice != '' ? swtch.dataset.subPrice : swtch.dataset.price;
              }
            }
            if(freqMsg != null  && swtch.dataset.freqMsgFirstPart != '' && swtch.dataset.freqMsgLastPart != ''){
              let freqFirstPart = swtch.dataset.freqMsgFirstPart
              let freqLastPart = swtch.dataset.freqMsgLastPart
              freqMsg.innerHTML = `<span class="light">${freqFirstPart}</span> ${freqLastPart}` 
            }
          })
        } else if (type == 'sub-options'){
          swatch.addEventListener('change',function(e){
            if(swatch.closest('[data-atc-container]').querySelector('[data-product-custom-diet-box]')!= null){
              swatch.closest('[data-atc-container]').querySelector('[data-product-custom-diet-box] input').checked = swatch.value != '' ? true : false;
              // console.log('checkedd',swatch.closest('[data-atc-container]').querySelector('[data-product-custom-diet-box] input').checked, swatch.value);
            }
            let atcBtnPrice = e.currentTarget.closest('[data-grid-prd-form]').querySelector('[data-atc-price]');
            if(atcBtnPrice != null) atcBtnPrice.innerHTML = e.currentTarget.dataset.atcPrc;
          });
        }
          
    
      }
      openATCPanel(ele,_this,productForms){
        productForms.forEach(function(form){
          if(ele != form){
            _this.closeATCPanel(form);
          }
        })
        
        ele.querySelector('button').classList.add('active');
        if(ele.querySelector('.atc-panel') != null) ele.querySelector('.atc-panel').classList.add('show');
        
        if(window.innerWidth<=1100 && ele.querySelector('[type="button"]') != null){
          setTimeout(function(){
            ele.querySelector('[type="button"]').type = 'submit';
          },50)
        }
      }
      closeATCPanel(ele){
        ele.querySelector('button').classList.remove('active');
        if(ele.querySelector('.atc-panel') != null) ele.querySelector('.atc-panel').classList.remove('show');

        if(window.innerWidth<=1100){
          setTimeout(function(){
           if(ele.querySelector('[data-add-step][type="submit"]') != null) ele.querySelector('[data-add-step][type="submit"]').type = 'button';
          },50)
        }
      }
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const atcLiveRegion = this.querySelector('#cart-atc-live-region');

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        atcLiveRegion.innerHTML = 'Adding....'

        let RandomNumber = Math.floor(Math.random() * 90000) + 10000;
        let stickyATCBtn = document.querySelector('[data-sticky-atc]');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form); 
        // for (const value of formData.values()) {
        //   console.log(value);
        // }
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        if(this.closest('[data-atc-container]')  != null && this.closest('[data-atc-container]').querySelector('[data-product-custom-diet-box] input:checked') != null){
          
          formData.append('properties[_bundle_number]',RandomNumber);
          formData.append('properties[_main_product]',true);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
               if(this.closest('[data-atc-container]')  != null && this.closest('[data-atc-container]').querySelector('[data-product-custom-diet-box] input:checked') != null){          
                this.cart.addAddonItem(this.closest('[data-atc-container]').querySelector('[data-product-custom-diet-box]'),RandomNumber);
              } else{
                this.cart.renderContents(response);
              }
              atcLiveRegion.innerHTML = 'Added to cart';
              
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            
            setTimeout(() =>{
              atcLiveRegion.innerHTML = 'Add to cart';
            },2000)

            if(stickyATCBtn != null){
              stickyATCBtn.querySelector('.product-form__buttons__text').classList.remove('hidden');
              stickyATCBtn.querySelector('.loading-overlay__spinner').classList.add('hidden');
            }
            
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
